import React, { useEffect, useState } from "react";
import Navbar from "../../components/Navbar";
import Styles from "../../styles/exercise/listexercise.module.scss";
import { Link, useNavigate } from "react-router-dom";
import { adminRoutes } from "../../routers/AdminRouters";
import Create from "../../assets/session/create.png";
import Delete from "../../assets/session/delete.png";
import Schedule from "../../assets/gym/calendar.png";
import Edit from "../../assets/exersise/pencil-edit.png";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import { deleteGym, getGym } from "../../services";
import Close_Button from "../../assets/auth/close.png";
import Suceess from "../../assets/session/deletepopup.png";
import { toggle } from "../../redux";
import InfiniteScroll from "react-infinite-scroll-component";
import { FaSearch } from "react-icons/fa";

const LIMIT = 15;

const ListGym = () => {
  const { gyms, isLoading } = useSelector((state) => state.gym);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isSidebarOpen = useSelector((state) => state.navbar.button);
  const [displayedGyms, setDisplayedGyms] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [sortOrder, setSortOrder] = useState("latest");
  const handleMainContainerClick = () => {
    if (isSidebarOpen) {
      dispatch(toggle());
    }
  };
  const fetchGyms = async (pageNum = page, query = "", sort = sortOrder) => {
    if (loading) return;

    try {
      setLoading(true);
      console.log("Fetching Gyms for page:", page);

      const newGyms = await getGym(false, pageNum, LIMIT, query, sort);

      if (newGyms && Array.isArray(newGyms) && newGyms.length > 0) {
        setDisplayedGyms((prev) => [...prev, ...newGyms]);
        setPage((prev) => prev + 1);
        console.log("Fetched new Gyms:", newGyms.length);
      } else {
        console.log("No more Gyms to fetch");
        setHasMore(false);
      }
    } catch (error) {
      console.error("Error fetching Gyms:", error);
      setHasMore(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchGyms();
  }, []);

  const handleSearch = async (e, sort = sortOrder) => {
    const query = e.target.value;
    setSearchQuery(query);

    try {
      if (query.trim() === "") {
        setDisplayedGyms([]);
        setPage(1);
        setHasMore(true);
        setTimeout(() => {
          fetchGyms(1, "", sort);
        }, 1);
      } else {
        const newGyms = await getGym(false, 1, -1, query, sort);
        if (Array.isArray(newGyms)) {
          setDisplayedGyms(newGyms);
          setHasMore(false);
        }
      }
    } catch (error) {
      console.error("Search error:", error);
    }
  };

  const handleSchedule = (gymId) => {
    navigate(adminRoutes.scheduleGym.replace(":gymId", gymId));
  };

  const handleEdit = (gymId) => {
    navigate(adminRoutes.editGym.replace(":gymId", gymId));
  };

  const handleDelete = (id) => {
    Swal.fire({
      html: `
        <div style="text-align: center; border-radius: 20px; position: relative;">
          <button 
            id="customCloseButton" 
            style="position: absolute; top:-5px; right:-10px; background: none; border: none; cursor: pointer;">
            <img 
              src=${Close_Button} 
              alt="Close" 
              style="width: 40px; height: 40px;"
            />
          </button>
          <img 
            src=${Suceess} 
            alt="Success" 
            style="width: 100px; margin-bottom: 10px; margin-top: 15px;" 
          />
          <h2 style="color:#151515;text-align:center;font-family:gothambold; font-size:18px;margin-bottom: 10px; ">Are you sure?</h2>
          <p style="color:#2E292A;text-align:center;font-family:gotham_bookregular; line-height:22px; font-size:14px;margin-bottom: 10px; ">
            Do you really want to delete these details? This process cannot be undone.
          </p>
          <button 
            id="cancel" 
            style="background: linear-gradient(0deg, #151515 0%, #525252 100%); color: #f3f3f6; padding: 10px 50px; font-size: 14px; font-family:gothambold; border: none; border-radius: 6px; cursor: pointer; margin-top: 10px;">
            Cancel
          </button>
          <br/>
          <button 
            id="delete" 
            style="background: #800505; color: #f3f3f6; padding: 10px 50px; font-size: 14px; font-family:gothambold; border-radius: 6px; cursor: pointer; margin-top: 10px;">
            Delete
          </button>
        </div>
      `,
      showConfirmButton: false,
      width: "400px",
      customClass: {
        popup: "custom-swal-container",
      },
      didOpen: () => {
        const cancel = document.getElementById("cancel");
        const deleteButton = document.getElementById("delete");
        const closeButton = document.getElementById("customCloseButton");

        cancel.addEventListener("click", () => {
          Swal.close();
        });
        deleteButton.addEventListener("click", async () => {
          Swal.close();
          const success = await deleteGym(id);
          if (success) {
            window.location.reload(adminRoutes.listGym);
          }
        });

        closeButton.addEventListener("click", () => {
          Swal.close();
        });
      },
    });
  };

  const handleCreateNewGym = () => {
    navigate(adminRoutes.createGym);
  };

  return (
    <>
      <Navbar />
      <div
        className={Styles.exercise_list_container_main}
        onClick={handleMainContainerClick}
      >
        <h2>
          <Link to={adminRoutes.dashboard}>HOME / </Link>
          <span>Gym Management</span>
        </h2>
        <div className={Styles.exercise_list_container}>
          <div className={Styles.table_container_heading}>
            <div className={Styles.table_container_headingone}>
              <h3>GYM &nbsp;LIST</h3>
            </div>
            <div className={Styles.table_container_headingtwo}>
              <select
                className={Styles.sortselect}
                value={sortOrder}
                onChange={(e) => {
                  const selected = e.target.value;
                  setSortOrder(selected);
                  setDisplayedGyms([]);
                  setPage(1);
                  setHasMore(true);

                  if (searchQuery.trim()) {
                    handleSearch({ target: { value: searchQuery } }, selected); // <-- pass selected sort
                  } else {
                    fetchGyms(1, searchQuery, selected); // <-- pass selected sort
                  }
                }}
              >
                <option value="latest">Latest Gyms</option>
                <option value="oldest">Oldest Gyms</option>
                <option value="asc">A - Z (Sort in ascending order)</option>
                <option value="desc">Z - A (Sort in descending order)</option>
              </select>

              <div
                className={`${Styles.searchContainerchildtwo} ${
                  searchQuery ? Styles.active : ""
                }`}
              >
                <FaSearch className={Styles.searchIcon} />
                <input
                  type="text"
                  className={Styles.searchInput}
                  placeholder="Search..."
                  value={searchQuery}
                  onChange={handleSearch}
                />
              </div>
              <div
                className={Styles.create_new_session}
                onClick={handleCreateNewGym}
                style={{ cursor: "pointer" }}
              >
                <img src={Create} alt="Create Icon" className={Styles.icon} />
                Create New Gym
              </div>
            </div>
          </div>

          <div className={Styles.tableFixedHeader}>
            <div className={Styles.scrollableWrapper}>
              <table className={Styles.exercise_table}>
                <thead>
                  <tr>
                    <th style={{ width: "20%" }}>Gym Name</th>
                    <th style={{ width: "20%" }}>Location</th>
                    <th style={{ width: "20%" }}>Contact Number</th>
                    <th style={{ width: "20%" }}>User Name</th>
                    <th style={{ width: "40%" }}>Action</th>
                  </tr>
                </thead>
              </table>

              <div id="scrollableDiv" className={Styles.scrollableContainer}>
                {!displayedGyms || displayedGyms.length === 0 ? (
                  <div className={Styles.no_sessions_container}>
                    <p
                      style={{
                        textAlign: "center",
                        padding: "10px",
                        color: "#f3f3f6",
                        fontFamily: "vanguard_cf_regular",
                      }}
                    >
                      No Gyms available
                    </p>
                  </div>
                ) : (
                  <InfiniteScroll
                    dataLength={displayedGyms.length}
                    next={fetchGyms}
                    hasMore={hasMore}
                    loader={
                      <>
                      </>
                    }
                    endMessage={
                      <p style={{ 
                        textAlign: "center", 
                        padding: "10px", 
                        color: "#f3f3f6", 
                        fontFamily: "gotham_bookregular",
                      }}>
                       
                      </p>
                    }
                    scrollableTarget="scrollableDiv"
                    scrollThreshold={0.8}
                  >
                    <table className={Styles.exercise_table}>
                      <tbody>
                        {displayedGyms
                          .filter((gym) => gym && gym.name)
                          .map((gym) => (
                            <tr key={gym._id}>
                              <td style={{ width: "20%" }}>
                                {gym.name?.length > 15
                                  ? `${gym.name.slice(0, 15)}...`
                                  : gym.name || "N/A"}
                              </td>
                              <td style={{ width: "20%" }}>
                                {gym.location || "N/A"}
                              </td>
                              <td style={{ width: "20%" }}>
                                {gym.phone || "N/A"}
                              </td>
                              <td style={{ width: "20%" }}>
                                {gym.username
                                  ? gym.username.length > 15
                                    ? `${gym.username.slice(0, 15)}...`
                                    : gym.username
                                  : "N/A"}
                              </td>

                              <td style={{ width: "40%" }}>
                                <button
                                  className={Styles.view_btn}
                                  onClick={() => handleSchedule(gym._id)}
                                >
                                  <img
                                    src={Schedule}
                                    alt="View Icon"
                                    className={Styles.delete_icon}
                                  />
                                  &nbsp; Schedule
                                </button>
                                <button
                                  className={Styles.edit_btn}
                                  onClick={() => handleEdit(gym._id)}
                                >
                                  <img
                                    src={Edit}
                                    alt="Edit Icon"
                                    className={Styles.delete_icon}
                                  />
                                  &nbsp; Edit
                                </button>
                                <button
                                  className={Styles.delete_btn}
                                  onClick={() => handleDelete(gym._id)}
                                >
                                  <img
                                    src={Delete}
                                    alt="Delete Icon"
                                    className={Styles.delete_icon}
                                  />
                                  &nbsp; Delete
                                </button>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </InfiniteScroll>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ListGym;
